module.exports = __webpack_public_path__ + "img/battery-full.96c00bae.svg";